import React from "react";
import Chart from "react-apexcharts";

function ChartJobStatus(prop) {
    // const series = [46, 32, 28, 18];
    var series =  [] ;
    if(prop.data === undefined){
    const options = {
        chart: {
            width: '100%'
        },
        colors: ['#000F9F', '#E8CD00', '#F2661C', '#B248BF'],
        fill: {
            colors: ['#000F9F', '#E8CD00', '#F2661C', '#B248BF']
        },
        markers: {
            colors: ['#fff', '#E91E63', '#9C27B0']
        },
        labels: ['Finish', 'On Process', 'No Assign', 'Reassign'],
        dataLabels: {
            enabled: false,
            enabledOnSeries: undefined,
            style: {
                colors: ['#fff', '#fff']
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
            },
        },
        legend: {
            fontSize: '10px',
            position: "bottom"
        },
        plotOptions: {
            pie: {
                customScale: 1.1,
                donut: {
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '22px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: "#333",
                            offsetY: -10,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '19px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 600,
                            color: "#000F9F",
                            offsetY: 0,
                            formatter: function (val) {
                                return val
                            }
                        },
                        total: {
                            show: true,
                            label: 'Job',
                            fontSize: '11px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: '#41434A',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            }
                        }
                    }
                },
            }
        }
    };

    return (
        <Chart options={options} series={series} type="donut" />
    )
    }
    else
    {
        return(false)
    }
}

export default ChartJobStatus














